export default Object.freeze({
    SITE_KEY: process.env.VUE_APP_CAPTCHA_SITE_KEY,
});
